@let editingSegment = store.editingSegmentSg();

<div class="atn-page-segment-dialog-query-tab">
  <div class="atn-page-segment-dialog-query-tab__content">
    <atn-ds-code
      class="atn-page-segment-dialog-query-tab__query-editor"
      label="Query"
      [json]="editingSegment.query"
      (jsonChange)="queryChangeHandler($event)"
    />

    <!-- TODO: Uncomment this once run query is implemented -->
    <!-- <atn-ds-code
      class="atn-page-segment-dialog-query-tab__preview"
      [readonly]="true"
    ></atn-ds-code> -->
  </div>
</div>
